export const EXTERNAL_COMPANY_HOLDINGS_APPROVED = "EXTERNAL_COMPANY_HOLDINGS_APPROVED";
export const EXTERNAL_COMPANY_HOLDINGS_SNOOZED = "EXTERNAL_COMPANY_HOLDINGS_SNOOZED";
